// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartBorderSettings.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * ChartBorderSettings Component
 */

import React from 'react';
import { toJS } from 'mobx';
import UIConstants from 'logic/data/Izenda.UIConstants';
import ChartSettingsContainer from './Izenda.ChartSettingsContainer';
import localizer from 'share/localization/Izenda.Localizer';
import DashStyle from 'share/components/controls/Izenda.DashStyleDropdown';
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('ChartBorderSettings')
class ChartBorderSettings extends React.Component {
  constructor(props) {
    super(props);

    this.allChartProps = toJS(props.allChartProps);
    var value = (props && props.value) || {};

    this.state = {
      visible: !!value['izEntire.borderWidth'],
      borderWidth: value['izEntire.borderWidth'],
      borderColor: value['izEntire.borderColor'] || UIConstants.borderColor,
      borderStyle: value['izEntire.borderStyle'] || UIConstants.defaultDashStyles
    };
  }

  getDefaultValue = () => {
    return {
      'izEntire.borderWidth': 0,
      'izEntire.borderColor': UIConstants.borderColor
    };
  };

  onChangeValue = (
    schemaData: Object,
    changedKey: any,
    changedKeyPath: any,
    changedValue: any,
    changedOthersInfo: any
  ) => {
    const groupData = changedKeyPath && changedKeyPath.length ? get(changedKeyPath, schemaData) : schemaData;
    const fieldData = groupData[changedKey];

    fieldData && (fieldData.value = changedValue);

    var borderWidth = schemaData.borderWidth.value;
    var isVisible = schemaData.visible.value;

    if (isVisible) {
      borderWidth = changedKey === 'visible' && !borderWidth ? UIConstants.borderWidth : borderWidth;
    } else {
      borderWidth = 0;
    }

    this.setState({
      visible: isVisible,
      borderWidth: borderWidth,
      borderColor: schemaData.borderColor.value,
      borderStyle: schemaData.borderStyle.value
    });
  };

  getValue = () => {
    var state = this.state;

    return {
      'izEntire.borderWidth': state.visible ? state.borderWidth : 0,
      'izEntire.borderColor': state.borderColor,
      'izEntire.borderStyle': state.borderStyle
    };
  };

  getSchema = state => {
    return {
      schemaKey: 'BORDER_SCHEMA',
      fields: {
        // visible
        visible: {
          title: localizer.getText('COMMON_LABEL_VISIBLE'),
          type: 'checkbox',
          controlClassName: 'u_controlHeight'
        },

        // color
        borderColor: {
          title: localizer.getText('COMMON_LABEL_COLOR'),
          type: 'color',
          props: {
            disabled: !state.visible
          }
        },

        // border style
        borderStyle: {
          title: localizer.getText('BORDER_SETTING_LABEL_DASH_STYLE'),
          component: 'DashStyle',
          props: {
            disabled: !state.visible
          }
        },

        // thickness
        borderWidth: {
          title: localizer.getText('BORDER_SETTING_LABEL_THICKNESS'),
          component: require('share/components/controls/Izenda.Thinkness'),
          props: {
            disabled: !state.visible
          }
        }
      }
    };
  };

  render() {
    const state = this.state;
    const chartOptions = {
      commonOptions: {
        'izEntire.borderWidth': state.borderWidth,
        'izEntire.borderColor': state.borderColor,
        'izEntire.borderStyle': state.borderStyle
      }
    };

    const configurationDef = {
      source: state,
      widgets: { DashStyle },
      definedSchema: this.getSchema(state),
      onChangeValue: this.onChangeValue
    };

    return (
      <ChartSettingsContainer
        type={this.props.reportPartType}
        configurationDef={configurationDef}
        chartOptions={chartOptions}
        allChartProps={this.allChartProps}
      />
    );
  }
}

export default ChartBorderSettings;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.ChartBorderSettings.js